import { css } from '@lyearn/style';

export const setWidth = (value: number) => css`
  width: ${value / 10}rem;
`;

export const setHeight = (value: number) => css`
  height: ${value / 10}rem;
`;

export const setTranslateXPercent = (value: number) => css`
  transform: translateX(${value}%);
`;
